import React, {useEffect, useState} from "react";
import {Button, Col, Form, message, Row, Space, Spin} from "antd";
import {InputFields} from "../../../../../../../components/common";
import {useAppDispatch, useAppSelector} from "../../../../../../../redux/hooks";
import {getPhongBanAPI} from "../../../../../../../redux/reducer/employee";
import {dataFields as inputFieldsInit} from "./config";
import {employeeService} from "api"
import Notification from "../../../../../../../components/common/notification/notification";
import dayjs from "dayjs";
import Icon from "../../../../../../../assets/icons";
import {field} from "../Tab1/config";
import {parseDatetime} from "../../../../../../../helper/format-date";


const Tab2 = props => {
  const {data, closeModal, type, getListApi, setCurrentPage} = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const employees = useAppSelector(
      (state) => state.employeesReducer
  );
  const dispatch = useAppDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [fieldInfo, setFieldInfo] = useState(inputFieldsInit);
  // useEffect(() => {
  //   if (isEditing !== false){
  //     const updatedFieldTT = inputFieldsInit.map(field => ({
  //       ...field,
  //           disable: false,
  //     }));
  //     setFieldInfo(updatedFieldTT);

  //   }else {
  //     const updatedFieldTT = inputFieldsInit.map(field => ({
  //       ...field,
  //       disable: field.disable == false ? true :  field.disable ,
  //     }));
  //     setFieldInfo(updatedFieldTT);

  //   }
  // }, [isEditing]);

  const handleSubmit = async () => {
    setLoading(true);
    const value = form.getFieldsValue();
    try {
      const params = {
        ...value,
        id:data.id ,
        gioPhongVan: parseDatetime(value.gioPhongVan, 'HH:mm:ss'),
        idDotTuyenDung:data.idDotTuyenDung,
        viTriUngTuyen:data.viTriUngTuyen,
        hoTen:data.hoTen,
        ngaySinh:data.ngaySinh,
        gioiTinh:data.gioiTinh,
        hoKhauThuongTru:data.hoKhauThuongTru,
        nguyenQuan:data.nguyenQuan,
        quocTich:data.quocTich,
        nuocCuTru:data.nuocCuTru,
        dienThoaiDiDong:data.dienThoaiDiDong,
        email:data.email,
        cccd:data.cccd,
        ngayCap:data.ngayCap,
        noiCap:data.noiCap,
        danToc:data.danToc,
        tonGiao:data.tonGiao,
        tinhTrangHonNhan:data.tinhTrangHonNhan,
        ngonNgu:data.ngonNgu,
        mucLuong:data.mucLuong,
        ngayNopHoSo:data.ngayNopHoSo,
        trinhDo:data.trinhDo,
        totNghiepTruong:data.totNghiepTruong,
        namTotNghiep:data.namTotNghiep,
        xepLoai:data.xepLoai,
        ghiChu:data.ghiChu,
        fileCV:data.fileCV,
        ketQuaPhongVan:data.ketQuaPhongVan,
        tenCvDinhKem:data.tenCvDinhKem,
        viTriUngTuyenTA: data.viTriUngTuyenTA,
        noiCapTA:data.noiCapTA,
        diaChiLamViec: data?.diaChiLamViec,
        diaChiLamViecTA: data?.diaChiLamViecTA,
      };
      const res = await employeeService.updateCandidateDirectory(params).then(res => {
        Notification("success", "Đã chỉnh sửa thành công ");
      });;
      setLoading(false);
      closeModal();
      await getListApi({});

    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi sửa thông tin lịch phỏng vấn");
    }
  };
  useEffect(() => {
    form.setFieldsValue({
      ...data,
      ngayPhongVan: data?.ngayPhongVan
          ? dayjs(data.ngayPhongVan)
          : null,
      gioPhongVan: data?.gioPhongVan ? dayjs(data.gioPhongVan, 'HH:mm'): null,



    });
  }, [data]);


  const handleEdit = () => {
    setIsEditing(true);
  };
  return (
      <div style={{ marginTop: 10 }}>
        <Spin spinning={loading}>
          <Form form={form} >
            <Space direction="vertical" style={{width: "100%"}}>
              <Row gutter={[16, 16]} >

                <InputFields data={fieldInfo}></InputFields>
              </Row>
              <Row justify="end" style={{ marginTop: 12 }}>
                <Col>
                  <Space>
                    <Button onClick={closeModal} style={{ backgroundColor: "red", borderColor: "red" , color: "white"  }}>Hủy bỏ</Button>
                    <Button htmlType="submit" type="primary" onClick={handleSubmit}>
                          Lưu lại
                        </Button>
                    {/* {isEditing ? (
                    ) : (
                        <Button
                            className="btn-sub"
                            type="ghost"
                            onClick={handleEdit}
                            icon={<Icon.edit />}
                        >
                          Chỉnh sửa
                        </Button>
                    )} */}
                  </Space>{" "}
                </Col>
              </Row>
            </Space>
          </Form>
        </Spin>
      </div>
  );
};
export default Tab2;
